import React from "react";
import { X, Share } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const LORA  = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const BADGE_STYLE = { borderRadius: "3px", background: "#F1EBE1", fontSize: "0.72rem" };

function StepBadge({ n }) {
  return (
    <span
      className="flex-shrink-0 w-5 h-5 rounded-full bg-[#C17F59] text-[#F9F6F0] text-xs flex items-center justify-center font-semibold"
      style={{ marginTop: "1px" }}
    >
      {n}
    </span>
  );
}

function InlineLabel({ children, withIcon }) {
  return (
    <span
      className={`inline-${withIcon ? "flex items-center gap-0.5" : "block"} px-1.5 py-0.5 border border-[#DCD4C6] text-[#2B2623] font-medium`}
      style={BADGE_STYLE}
    >
      {withIcon && <Share size={10} strokeWidth={2} />}
      {children}
    </span>
  );
}

export function IOSInstallPopup({ popupRef, onClose }) {
  const { t } = useLanguage();

  return (
    <div
      ref={popupRef}
      className="absolute right-0 mt-2 z-50 animate-fade-in"
      style={{ width: "280px" }}
      data-testid="ios-install-popup"
    >
      <div
        className="border border-[#DCD4C6] shadow-lg overflow-hidden"
        style={{ background: "#F9F6F0", borderRadius: "3px" }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-4 py-3 border-b border-[#DCD4C6]"
          style={{ background: "#F1EBE1" }}
        >
          <p className="text-sm text-[#2B2623]" style={{ ...SERIF, fontWeight: 600, fontSize: "1rem" }}>
            {t("pwa.ios_title")}
          </p>
          <button
            onClick={onClose}
            className="text-[#9A8F86] hover:text-[#2B2623] transition-colors"
            data-testid="ios-popup-close"
          >
            <X size={14} strokeWidth={1.5} />
          </button>
        </div>

        {/* Steps */}
        <div className="px-4 py-4 space-y-3">
          <div className="flex items-start gap-3">
            <StepBadge n={1} />
            <p className="text-xs text-[#2B2623]" style={{ ...LORA, lineHeight: 1.6 }}>
              {t("pwa.ios_step1_pre")}{" "}
              <InlineLabel withIcon>{t("pwa.ios_step1_btn")}</InlineLabel>
              {" "}{t("pwa.ios_step1_post")}
            </p>
          </div>
          <div className="flex items-start gap-3">
            <StepBadge n={2} />
            <p className="text-xs text-[#2B2623]" style={{ ...LORA, lineHeight: 1.6 }}>
              {t("pwa.ios_step2_pre")}{" "}
              <InlineLabel>{t("pwa.ios_step2_btn")}</InlineLabel>
            </p>
          </div>
          <div className="flex items-start gap-3">
            <StepBadge n={3} />
            <p className="text-xs text-[#2B2623]" style={{ ...LORA, lineHeight: 1.6 }}>
              {t("pwa.ios_step3_pre")}{" "}
              <InlineLabel>{t("pwa.ios_step3_btn")}</InlineLabel>
            </p>
          </div>
        </div>

        {/* Arrow indicator pointing at the button */}
        <div
          className="absolute -top-2 right-4 w-0 h-0"
          style={{ borderLeft: "7px solid transparent", borderRight: "7px solid transparent", borderBottom: "7px solid #DCD4C6" }}
        />
        <div
          className="absolute -top-1.5 right-4 w-0 h-0"
          style={{ borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderBottom: "6px solid #F1EBE1" }}
        />
      </div>
    </div>
  );
}
